import axios from "axios";
import i18n from "i18n";

export const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 3600000,
  headers: {
    "ngrok-skip-browser-warning": "true",
  },
});
axiosClient.interceptors.request.use(
  (config) => {
    const hasAccessToken = localStorage.getItem("token");
    if (hasAccessToken) {
      config.headers.Authorization = `Bearer ${hasAccessToken}`;
    }
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosClient.interceptors.response.use(
  (response) => {
    if (response && response.data && response.data.type === "application/pdf") {
      return response.data;
    } else if (response.status === 200 || response.status === 201) {
      return response.data;
    }
    return Promise.reject(response);
  },
  (error) => {
    const data = error?.response?.data || {
      data: {
        success: false,
        message: i18n.t("auth:errors.generic"),
      },
    };
    switch (error?.response?.status) {
      case 400:
        return Promise.reject(data);
      case 401:
        localStorage.removeItem("token");
        window.location.reload();
        return Promise.reject(data);
      case 403:
        return Promise.reject(data);
      case 404:
        return Promise.reject(data);
      case 405:
        return Promise.reject(data);
      case 409:
        return Promise.reject(data);
      case 500:
        return Promise.reject(data);
      case 501:
        return Promise.reject(data);
      case 422:
        return Promise.reject(data);
      default:
        return Promise.reject(data);
    }
  }
);
